import * as React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { HEADER } from '../../../constants/template-builder';
import { HeaderActions } from './header-actions';
type TemplateHeaderPropsT = {
  onClearCanvas: () => void;
  onSaveTemplate: () => void;
  onClose: () => void;
};
const getContainerStyles = (theme: Theme) => ({
  display: ('flex' as const),
  alignItems: ('center' as const),
  justifyContent: ('space-between' as const),
  backgroundColor: theme.colors.backgroundPrimary,
  borderBottom: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`,
  padding: `${theme.sizing.scale500} ${theme.sizing.scale800}`,
  boxSizing: ('border-box' as const)
});
const getTitleStyles = (theme: Theme) => ({
  ...theme.typography.HeadingXSmall,
  whiteSpace: ('nowrap' as const)
});
export function TemplateHeader({
  onClearCanvas,
  onSaveTemplate,
  onClose
}: TemplateHeaderPropsT) {
  const [css, theme] = useStyletron();
  return <div className={css(getContainerStyles(theme))}>
      <div className={css(getTitleStyles(theme))}>{HEADER.HEADER_TITLE}</div>

      <HeaderActions onClearCanvas={onClearCanvas} onSaveTemplate={onSaveTemplate} onClose={onClose} />
    </div>;
}